<template>
  <div class="row">
    <h2>{{ $t('invitationRecords') }}</h2>
    <div class="invite-banner">
      <div class="content-box" id="friend-num">
        <div class="content">
          <p class="little-title">{{ $t('inviteFriends') }}</p>
          <p class="main-num">{{ user.invitation_count }}</p>
          <p class="unit">{{ user.invitation_count <= 1 ? $tc('referrals', 1) : $tc('referrals', 2) }}</p>
          <p class="explain">{{ $t('numDescribe') }}</p>
        </div>
      </div>

      <div class="content-box" id="reward-days">
        <div class="content">
          <p class="little-title">{{ $t('reward') }}</p>
          <p class="main-num">{{ user.award_days }}</p>
          <p class="unit">{{ user.award_days <= 1 ? $tc('days', 1) : $tc('days', 2) }}</p>
          <p class="explain">{{ $t('instructions') }}</p>
        </div>
      </div>

      <div class="content-box" id="invite-friend-box">
        <invite-friend id="invite-code-box" :invitation-code="user.invitation_code"></invite-friend>
      </div>

    </div>
    <p class="clearfix"></p>

    <invite-record></invite-record>

  </div>
</template>

<script>
  import InviteRecord from '../../components/affiliate/inviteRecord/InviteRecord.vue'
  import InviteFriend from '../../components/inviteFriend/InviteFriend.vue'
  import locales from './lang'
  import { mapState } from 'vuex'

  export default {
    name: 'affiliate',
    components: {InviteRecord, InviteFriend},
    locales,
    computed: {
      ...mapState({
        user: state => state.user,
        language: state => state.currentLang
      })
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/variables";

  * {
    padding: 0;
    margin: 0;
  }

  h2 {
    display: none;
    @media screen and (max-width: 767px) {
      display: block;
      font-size: .24rem;
      line-height: 32px;
      color: #111111;
      font-weight: 600;
      text-align: center;
      margin-bottom: 0.24rem;
    }
  }

  .invite-banner {
    width: 100%;
    .content-box {
      display: inline-block;
      float: left;
      padding-right: .24rem;
    }
    .content {
      border: 1px solid #e0d7e3;
      border-radius: .08rem;
      text-align: center;
      min-height: 2.85rem;
      margin-bottom: .24rem;
    }
    .little-title {
      font-size: .16rem;
      padding: 0 .16rem;
      line-height: .48rem;
      height: .48rem;
      border-bottom: 1px solid #e0d7e3;
      margin-bottom: .24rem;
      color: #111;
      letter-spacing: 0;
      text-align: left;
    }
    .main-num {
      letter-spacing: 0;
      font-size: .58rem;
      color: #111;
      line-height: .58rem;
      height: .58rem;
      margin-bottom: .08rem;
      span {
        font-size: 14px;
        color: #111;
        letter-spacing: 0;
      }
    }

    .unit {
      font-size: 12px;
      color: #666;
      letter-spacing: 0;
      margin-bottom: .24rem;
      line-height: .18rem;
    }

    .explain {
      font-size: 14px;
      color: #666;
      letter-spacing: 0;
      line-height: .2rem;
      padding: 0 .16rem;
    }

    #friend-num, #reward-days {
      width: 284px;
    }

    #invite-friend-box {
      width: calc(100% - 284px *2);
      padding-right: 0;
    }

    @mixin phoneStyle() {
      #friend-num, #reward-days, #invite-friend-box {
        width: 100%;
        padding: 0;
      }
      #invite-code-box {
        height: auto;
        padding-bottom: .2rem;
        border-radius: .05rem;
      }

    }

    @mixin padStyle() {
      #friend-num, #reward-days {
        width: 50%;
        padding: 0;
      }
      #friend-num {
        padding-right: .1rem;
      }
      #reward-days {
        padding-left: .1rem;
      }
      #invite-friend-box {
        width: 100%;
      }
    }

    @media (max-width: 1393px) {
      @include padStyle();
    }

    @media (max-width: 767px) {
      @include phoneStyle();
      .content {
        border-radius: .05rem;
        padding-bottom: 0.24rem;
        min-height: auto;
      }
      .little-title {
        height: 44px;
        line-height: 44px;
        font-size: 14px;
        margin-bottom: .2rem;
      }
      .main-num {
        height: .48rem;
        line-height: .48rem;
        font-size: .48rem;
        margin-bottom: .03rem;
      }
      .unit {
        margin-bottom: .16rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// IndexMain.vue?9fa85242